export default () => {
  const configurationGlobals = {};

  const globals = Object.entries(window.$App.globals.containers)
  globals.forEach((global) => (configurationGlobals[`$${global[0].toUpperCase()}`] = global[1]))

  return configurationGlobals
}